'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


/**
 * TAKEN FROM: https://gist.github.com/andersfly/25ab13dbd1acc5eb915f
 * Detects drag modifier keys on drag events that originated
 * from the wrapped component
 *
 * @param {boolean} options.listenForAllDragEvents
 *   if true it will detect modifier keys for all drag events, and not
 *   just the ones originating from the wrapped component
 */


// Actions


// Constants


var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dragModifierKeysActions = require('./dragModifierKeysActions');

var _dragModifierKeysConstants = require('./dragModifierKeysConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// All false
var initialDragModifierKeys = _dragModifierKeysConstants.MODIFIER_KEYS_NAMES.reduce(function (mem, key) {
    mem[key] = false;
    return mem;
}, {});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchSetModifierKeys: function dispatchSetModifierKeys(modifierKeys) {
            return dispatch((0, _dragModifierKeysActions.setDragModifierKeys)(modifierKeys));
        }
    };
};

var DragModifierKeysListener = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(DragModifierKeysListener, _React$Component);

    function DragModifierKeysListener(props) {
        _classCallCheck(this, DragModifierKeysListener);

        var _this = _possibleConstructorReturn(this, (DragModifierKeysListener.__proto__ || Object.getPrototypeOf(DragModifierKeysListener)).call(this, props));

        _this.checkEventModifierKeys = function (event) {
            var hasChanged = Object.keys(_this.dragModifierKeys).some(function (key) {
                return _this.dragModifierKeys[key] !== event[key];
            });

            if (hasChanged) {
                _this.dragModifierKeys = (0, _lodash.pick)(event, _dragModifierKeysConstants.MODIFIER_KEYS_NAMES);
                _this.props.dispatchSetModifierKeys(_this.dragModifierKeys);
            }
        };

        _this.onDragStart = _this.checkEventModifierKeys;
        _this.onDrag = _this.checkEventModifierKeys;

        _this.onDragEnd = function () {
            _this.dragModifierKeys = initialDragModifierKeys;
        };

        _this.dragModifierKeys = initialDragModifierKeys;
        return _this;
    }

    _createClass(DragModifierKeysListener, [{
        key: 'componentDidMount',
        value: function componentDidMount(event) {
            window.addEventListener('dragstart', this.onDragStart);
            // The 'drag' event doesn't detect modifier keys in FF for some reason.
            // Therefore we listen for dragover on the window instead, which roughly
            // gives the same result
            window.addEventListener('dragover', this.onDrag);
            window.addEventListener('dragend', this.onDragEnd);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount(event) {
            window.removeEventListener('dragstart', this.onDragStart);
            window.removeEventListener('dragover', this.onDrag);
            window.removeEventListener('dragend', this.onDragEnd);
        }

        /* eslint-disable react/sort-comp */

        /* eslint-enable react/sort-comp */

    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return DragModifierKeysListener;
}(_react2.default.Component)) || _class);


DragModifierKeysListener.propTypes = {
    dispatchSetModifierKeys: _propTypes2.default.func
};

exports.default = DragModifierKeysListener;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/modifierKeys/DragModifierKeysListener.js
// module id = 2120
// module chunks = 0